import { FIELD_GEOMETRY, fieldClass, POPUP_SURFACE } from './surfaces';

/**
 * Shared Tailwind class strings. Kept as plain constants so both Server and
 * Client Components can use them without pulling in a styling runtime.
 */

export const MUTED = 'text-sm text-muted-foreground';

export const PAGE_TITLE = 'type-page-title tracking-tight';

/** A native form control styled as the shared text field. */
export const DESKTOP_FIELD = fieldClass(FIELD_GEOMETRY, 'w-full');

/** The charter's card: the surface colour, 10 px corners (append padding, e.g. `${PANEL_CARD} p-5`). */
export const PANEL_CARD = 'rounded-card border border-hairline-faint bg-card text-card-foreground';

/** Floating desktop menu/dropdown surface: the shared popup surface with menu geometry. */
export const DESKTOP_MENU_SURFACE = `${POPUP_SURFACE} rounded-xl p-1`;
